import { IPhone } from '../../../types/newbuilding/builder';

export const isCorrectPhoneObject = (phone?: IPhone | null): boolean => {
  return !!(phone && phone.countryCode && phone.code && phone.number);
};
